import request from '@api/request';

type YaCounter = {
  reachGoal: (goal: string, callback?: () => void) => void;
  setUserID: (id: unknown) => void;
  userParams: (params: unknown) => void;
};

declare global {
  interface Window {
    yaCounter55552873?: YaCounter;
  }
}

export function awaitForMetrikaScript(): Promise<void> {
  return new Promise((resolve) => {
    if (process.env.NODE_ENV === 'development') {
      resolve();
      return;
    }

    const timeoutFunction = () => {
      if (window.yaCounter55552873) {
        resolve();
        return;
      }

      setTimeout(timeoutFunction, 100);
    };

    timeoutFunction();
  });
}

export function reachGoal(goal: string, callback?: () => void): void {
  if (process.env.NODE_ENV === 'production') {
    if (window.yaCounter55552873) {
      window.yaCounter55552873.reachGoal(goal, callback);
    } else if (callback) {
      callback();
    }
  } else if (callback) {
    callback();
  }
}

export function trackUser(): void {
  request.get('/api/user.json').then((response) => {
    if (process.env.NODE_ENV === 'production') {
      if (window.yaCounter55552873) {
        window.yaCounter55552873.setUserID(response.data.id);
        window.yaCounter55552873.userParams(response.data);
      }
    }
  });
}

export const GOALS = {
  // Регистрация
  SIGNUP_REGISTER_BUTTON: 'register_button', // Клик по кнопке "зарегистрироваться"

  // Вход
  LOGIN_BUTTON: 'login_button', // Клик по кнопке "Вход"
  SIGNIN_BUTTON: 'signin_button',
  FORGOT_PASSWORD_BUTTON: 'forgot_password_button', // Клик по кнопке "забыли пароль"
  RESET_PASSWORD_BUTTON: 'reset_password_button', // Клик по кнопке "Восстановление пароля"
  SAVE_AND_LOGIN_BUTTON: 'save_and_login_button', // Клик по кнопке "сохранить и войти"

  // Корзина
  ADD_TO_CART_BUTTON: 'add_to_cart', // Добавил товар в корзину
  PROCEED_TO_CHECKOUT_BUTTON: 'proceed_to_checkout', // Переход к оформлению заказа
  // Хеддер кнопки и "в корзине"
  HEADER_CART_BUTTON: 'header_cart_button',
  // Оформить заказ
  PURCHASE_BUTTON: 'purchase'
} as const;
